/**
 * @generated SignedSource<<c9897ba313c3296d413bf19d6a5ec07b>>
 * @relayHash 93532fcb5b1563541fbed098abfe8c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a5854e1e10a16934acc024877272de440ef430aa73018f0dab1f1b55da42a59f

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSetIssueSearchHideDoneItemsInput = {
  hideDoneItems: boolean;
  viewId: string;
};
export type updateHideDoneToggleMutation$variables = {
  input: JiraSetIssueSearchHideDoneItemsInput;
};
export type updateHideDoneToggleMutation$data = {
  readonly jira_setIssueSearchHideDoneItems: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type updateHideDoneToggleMutation = {
  response: updateHideDoneToggleMutation$data;
  variables: updateHideDoneToggleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "updateHideDoneToggleMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchHideDoneItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateHideDoneToggleMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
        "kind": "LinkedField",
        "name": "jira_setIssueSearchHideDoneItems",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a5854e1e10a16934acc024877272de440ef430aa73018f0dab1f1b55da42a59f",
    "metadata": {},
    "name": "updateHideDoneToggleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "388b8d343d54f6cc52149389b7be18c6";

export default node;
